// context creation  --
// provider  --
// consumer lengthy remove use context hook
// useContext hook --
import  React, {useContext, useReducer, useState}from "react";
import {useEffect} from "react";
import reducer from "./reducer"; 

const initialState={
isLoading : true,
query:"HTML",
nbPages:0,
page:0,
hits: [],
};
const AppContext = React.createContext();

// toprovide a provider  function
const AppProvider =({children})=>{
    // const [state, setstate] = useState(initialState);
    const [state, dispatch] = useReducer(reducer, initialState);

    let API1 = "https://hn.algolia.com/api/v1/search?";

    // https://hn.algolia.com/api/v1/search?query=html <= this is the api url


const fetchApiData = async (url) => {

    dispatch({type:"SET_LOADING"});

  try{
    const res= await fetch(url);
    const data = await res.json();
    console.log(data);
    dispatch({type:"GET_STORIES",
        payload: {
            hits: data.hits,
            nbpages: data.nbPages,
        },
    });

    // isLoading =  false;
  }catch (error){
    console.log(error);
  }
};

// to remove the post
const removePost = (post_ID) => {
 dispatch({type:"REMOVE_POST", payLoad: post_ID });
};

// to Search the element
const searchPost = (searchQuery) => {
dispatch({type: "SEARCH_QUERY",
  naman: searchQuery, //can use the keyword payload as well
});
};

// to do pagination 
const getNextPage = () => {
  dispatch({
    type:"NEXT_PAGE",
  })
}
const getPrevPage = () => {
  dispatch({
    type:"PREV_PAGE",
  })
}


// to call the api function 
useEffect(()=>{
  fetchApiData(`${API1}query=${state.query}&page=${state.page}`);
}, [state.query, state.page]);

    return (
        <AppContext.Provider value={{ ...state, removePost, searchPost,getNextPage,getPrevPage}}>
            {children}
        </AppContext.Provider>
    );
};

//custom hooks creation
const useGlobalContext =()=> {
    return useContext(AppContext);
};
export {AppContext,AppProvider,useGlobalContext};